import { Component } from '@angular/core';
import { ErrorScreenComponent } from './error-screen.component';
import { ErrorScreenType } from './error-screen.types';

@Component({
  selector: 'k-not-found-page',
  template: `
    <k-error-screen [type]="ErrorScreenType.PAGE_NOT_FOUND"></k-error-screen>`,
  imports: [ ErrorScreenComponent ],
})
export class NotFoundPageComponent {
  protected readonly ErrorScreenType = ErrorScreenType;
}
